import { useEffect, useState } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { Loader2 } from 'lucide-react'
import { toast } from 'sonner'
import { supabase } from '@/lib/supabase'
import { useAuth } from '@/providers/auth-provider'
import { useWorkspace } from '@/providers/workspace-provider'
import { Button } from '@/components/ui/button'
import { AuthShell } from './auth-shell'

/**
 * Aceite de convite por token. Usa a RPC `redeem_invitation`.
 * Requer usuário autenticado com o mesmo e-mail do convite.
 */
export function InvitePage() {
  const [params] = useSearchParams()
  const token = params.get('token')
  const { session } = useAuth()
  const { refetch } = useWorkspace()
  const navigate = useNavigate()
  const [state, setState] = useState<'idle' | 'loading' | 'done' | 'error'>('idle')
  const [message, setMessage] = useState('')

  useEffect(() => {
    if (!token || !session) return
    setState('loading')
    supabase.rpc('redeem_invitation', { p_token: token }).then(({ error }) => {
      if (error) {
        setState('error')
        setMessage(error.message)
      } else {
        setState('done')
        refetch()
        toast.success('Convite aceito')
        setTimeout(() => navigate('/', { replace: true }), 1200)
      }
    })
  }, [token, session, navigate, refetch])

  if (!token) {
    return (
      <AuthShell title="Convite inválido">
        <p className="text-sm text-muted-foreground">O link não contém um token de convite.</p>
      </AuthShell>
    )
  }

  if (!session) {
    return (
      <AuthShell title="Aceitar convite" subtitle="Entre com o e-mail que recebeu o convite.">
        <Button asChild className="w-full">
          <Link to={`/entrar?next=/convite?token=${token}`}>Ir para o login</Link>
        </Button>
      </AuthShell>
    )
  }

  return (
    <AuthShell title="Aceitando convite">
      <div className="flex flex-col items-center gap-3 text-center text-sm">
        {state === 'loading' && <Loader2 className="h-6 w-6 animate-spin text-primary" />}
        {state === 'done' && <p className="text-success">Tudo certo! Redirecionando…</p>}
        {state === 'error' && (
          <>
            <p className="text-destructive">Não foi possível aceitar: {message}</p>
            <Button asChild variant="outline">
              <Link to="/">Ir para o app</Link>
            </Button>
          </>
        )}
      </div>
    </AuthShell>
  )
}
